import { getGridNumericOperators } from '@mui/x-data-grid';

const FILTER_KEYS = {
  Contains: 'contains',
  Equals: 'equal',
  NotEqual: 'not_equal',
  StartsWith: 'starts_with',
  EndsWith: 'ends_with',
  IsEmpty: 'is_null',
  Is: 'is',
  IsNot: 'is_not',
  IsAfter: 'is_after',
  IsOnOrAfter: 'is_on_or_after',
  IsBefore: 'is_before',
  IsOnOrBefore: 'is_on_or_before',
  IsNotEmpty: 'is_not_null',
  GreaterThen: 'greater_than',
  GreaterThenOrEqual: 'greater_than_equal',
  LessThen: 'less_than',
  LessThenOrEqual: 'less_than_equal',
  IsNotOn: 'is_not_on',
  IsOn: 'is_on',
};

export const MUI_TABLE_FILTER_OPERATORS = {
  contains: FILTER_KEYS.Contains,
  startsWith: FILTER_KEYS.StartsWith,
  endsWith: FILTER_KEYS.EndsWith,
  '=': FILTER_KEYS.Equals,
  '!=': FILTER_KEYS.NotEqual,
  '>': FILTER_KEYS.GreaterThen,
  '<': FILTER_KEYS.LessThen,
  '>=': FILTER_KEYS.GreaterThenOrEqual,
  '<=': FILTER_KEYS.LessThenOrEqual,
  isEmpty: FILTER_KEYS.IsEmpty,
  isNotEmpty: FILTER_KEYS.IsNotEmpty,
  equals: FILTER_KEYS.Equals,
  notEqual: FILTER_KEYS.NotEqual,
  not: FILTER_KEYS.IsNot,
  is: FILTER_KEYS.Is,
  after: FILTER_KEYS.IsAfter,
  onOrAfter: FILTER_KEYS.IsOnOrAfter,
  before: FILTER_KEYS.IsBefore,
  onOrBefore: FILTER_KEYS.IsOnOrBefore,
  isNotOn: FILTER_KEYS.IsNotOn,
  isOn: FILTER_KEYS.IsOn,
  doesNotEqual: FILTER_KEYS.NotEqual,
};

const numberOperatorsWithValue = getGridNumericOperators()
  .filter(({ value }) => !['isEmpty', 'isNotEmpty', 'isAnyOf'].includes(value))
  .map(({ value }) => value);
export const isNumberOperator = (operator) =>
  numberOperatorsWithValue.includes(operator);
